export const version = '2.9.1';
//# sourceMappingURL=version.js.map